<script lang="ts" setup>
import type { PurchasedOrder, PurchasedOrderGift } from '@consumer/types/serializers'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import OrderDetailsPreview from '@consumer/modules/shared/OrderDetailsPreview.vue'
import OrderGiftContent from '@consumer/modules/buyer/OrderGiftContent.vue'

defineProps<{
  orderGift: PurchasedOrderGift
  order: PurchasedOrder
  linkToSupportPage?: boolean
}>()
</script>

<template>
  <div
    :id="`order-gift-${orderGift.uuid}`"
    class="text-sm rounded-v2md border-1 border-solid border-grey-primary p-4 flex flex-col shadow-v2sm"
  >
    <div class="flex flex-col lg:flex-row gap-6 relative">
      <div class="w-100px lg:w-150px">
        <OrderDetailsPreview :gift="orderGift"/>
      </div>

      <OrderGiftContent
        :orderGift="orderGift as PurchasedOrderGift"
        :order="order"
        wrapDateLine
      />
    </div>
    <template v-if="linkToSupportPage">
      <GDivider class="block" style=" height: 1px;margin: 1.25rem 0 1rem;"/>

      <GButton
        :id="`order-gift-${orderGift.uuid}-view-gift-support-link`"
        flat
        primary
        style="justify-content: space-between;"
        label="View gift support"
        :iconRight="faChevronRight"
        :href="orderGift.purchaserSupportUrl"
        target="_blank"
      />
    </template>
  </div>
</template>
